import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    controlsInactive: '!op-0',
    progressControls: 'absolute bottom-0 right-0 z-4 flex px-5 py-2 lg:p-6'
  },
  controlsSize: 'md'
} satisfies VfConfig['carousel']
